import RefreshRounded from "@mui/icons-material/RefreshRounded";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { endOfDay } from "date-fns/endOfDay";
import { useFaultMonitorData } from "./hooks/useFaultMonitorData";
import { PresetSelect } from "@/components/filter/PresetSelect";
import { usePersistedDateRange } from "@/hooks/userState/usePersistedDateRange";
import { mapLazy } from "@/utilities/mapLazy";

const FilterStackLayout = mapLazy(
  "FilterStackLayout",
  import("@/components/layout/FilterStackLayout"),
);
const FaultGrid = mapLazy("FaultGrid", import("./components/FaultGrid"));
const DateRangeSelect = mapLazy("DateRangeSelect", import("@/components/input/DateRangeSelect"));

export default function FaultOverviewPage() {

  const { fromDate, toDate, setRange, isReady } = usePersistedDateRange({
    key: "dateRange:faultMonitor",
    defaultLookbackDays: 1,
  });

  const { data, refetch } = useFaultMonitorData(fromDate, toDate, isReady);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  return (
    <FilterStackLayout
      isMobile={isMobile}
      filters={
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            width: "100%",
            gap: 2,
          }}
        >
          <Button variant="outlined" sx={{ height: 40 }} onClick={() => refetch()}>
            <RefreshRounded />
          </Button>
          <DateRangeSelect
            toDate={toDate}
            fromDate={fromDate}
            onChange={(from, to) => {
              setRange(from, to ?? (from ? endOfDay(from) : undefined));
            }}
          />
          <PresetSelect />
        </Box>
      }
      //<DiagnosticSelect selectedDiagnostics={diagnosticIds} setSelectedDiagnostics={setSelectedDiagnostics} />
      //<DiagnosticPresetsModal selectedDiagnostics={selectedDiagnostics} onPresetSelected={setSelectedDiagnostics} me={me} />
      content={<FaultGrid data={data} fromDate={fromDate} toDate={toDate} />}
    />
  );
}
